module.exports = __webpack_public_path__ + "img/cn-pro.a16c8ff3.png";